let DataService = {};
DataService.urlDownloadAppTourGuideCHPlay =
  "https://play.google.com/store/apps/details?id=com.biin.tourism.guide";
DataService.urlDownloadAppTourGuideIOS =
  "https://apps.apple.com/us/app/h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-vi%C3%AAn-du-l%E1%BB%8Bch-vi%E1%BB%87tnam/id1489028074?ls=1";

DataService.Languages = [
  {
    id: "vi",
    name: "Tiếng Việt",
  },
  {
    id: "en",
    name: "Tiếng Anh",
  },
  {
    id: "zh",
    name: "Tiếng Trung",
  },
  {
    id: "ja",
    name: "Tiếng Nhật",
  },
  {
    id: "fr",
    name: "Tiếng Pháp",
  },
  {
    id: "es",
    name: "Tiếng Tây Ban Nha",
  },
  {
    id: "hi",
    name: "Tiếng Hindi (Ấn Độ)",
  },
  {
    id: "pt",
    name: "Tiếng Bồ Đào Nha",
  },
  {
    id: "de",
    name: "Tiếng Đức",
  },
  {
    id: "ko",
    name: "Tiếng Hàn Quốc (Triều Tiên)",
  },
  {
    id: "lo",
    name: "Tiếng Lào",
  },
  {
    id: "km",
    name: "Tiếng Khmer (Campuchia)",
  },
  {
    id: "th",
    name: "Tiếng Thái",
  },
  {
    id: "ru",
    name: "Tiếng Nga",
  },
];
DataService.gioiTinhRegister = [
  {
    code: "2",
    text: "Nữ",
  },
  {
    code: "1",
    text: "Nam",
  },
  {
    code: "3",
    text: "Khác",
  },
];
DataService.doiTuongPhanHoi = [
  {
    code: "DNLH",
    text: "Doanh nghiệp lữ hành",
  },
  {
    code: "TOUR",
    text: "Tour",
  },
  {
    code: "HDV",
    text: "Hướng dẫn viên",
  },
  {
    code: "CSLT",
    text: "Cơ sở lưu trú",
  },
  {
    code: "DDAT",
    text: "Điểm đến",
  },
];
DataService.loaiHinhRegister = [
  {
    code: "international_travel",
    text: "Lữ hành quốc tế",
  },
  {
    code: "domestic_travel",
    text: "Lữ hành nội địa",
  },
  {
    code: "hotel",
    text: "Khách sạn",
  },
  {
    code: "tourist_villa",
    text: "Biệt thự du lịch",
  },
  {
    code: "tourist_apartment",
    text: "Căn hộ du lịch",
  },
  {
    code: "tourist_cruise",
    text: "Tầu thủy lưu trú du lịch",
  },
  {
    code: "camping",
    text: "Bãi cắm trại du lịch",
  },
  {
    code: "motel",
    text: "Nhà nghỉ du lịch",
  },
  {
    code: "homestay",
    text: "Nhà ở có phòng cho khách du lịch thuê/Homestay",
  },
  {
    code: "tourist_carriers",
    text: "Vận tải khách",
  },
  {
    code: "shopping",
    text: "Điểm mua sắm",
  },
  {
    code: "restaurant",
    text: "Nhà hàng",
  },
  {
    code: "tourist_area",
    text: "Khu du lịch",
  },
  {
    code: "tourist_attraction",
    text: "Điểm du lịch",
  },
  {
    code: "entertainment",
    text: "Địa điểm vui chơi, giải trí",
  },
];
DataService.gioiTinh = [
  {
    id: 1,
    text: "Nữ",
  },
  {
    id: 2,
    text: "Nam",
  },
  {
    id: 3,
    text: "Chưa có thông tin",
  },
  {
    id: 4,
    text: "Khác",
  },
];

DataService.danhSachTrang = [
  //
  {
    value: "TrangChu",
    label: "Trang chủ",
  },
  {
    value: "GioiThieu",
    label: "Giới thiệu",
  },
  {
    value: "DiemDen",
    label: "Điểm đến",
  },
  {
    value: "ChiTietDiemDen",
    label: "Chi tiết điểm đến",
  },
  {
    value: "Tour",
    label: "Tour",
  },
  {
    value: "ChiTietTour",
    label: "Chi tiết tour",
  },
  {
    value: "LuuTru",
    label: "Lưu trú",
  },
  {
    value: "ChiTietLuuTru",
    label: "Chi tiết lưu trú",
  },
  {
    value: "AmThuc",
    label: "Ẩm thực",
  },
  {
    value: "ChiTietAmThuc",
    label: "Chi tiết ẩm thực",
  },
  {
    value: "GiaiTri",
    label: "Giải trí",
  },
  {
    value: "ChiTietGiaiTri",
    label: "Chi tiết giải trí",
  },
  {
    value: "VeDienTu",
    label: "Vé điện tử",
  },
  {
    value: "TinTuc",
    label: "Tin tức",
  },
  {
    value: "ChiTietTinTuc",
    label: "Chi tiết tin tức",
  },
];

DataService.accountRoles = [
  // {
  //   code: 'Admin',
  //   text: "Quản trị hệ thống"
  // },
  // {
  //     code: "*",
  //     text: "*"
  // },
  {
    code: "Officer",
    text: "Cơ quan quản lý",
  },
  {
    code: "TrangVangCompanyManager",
    text: "Quản lý doanh nghiệp",
  },
  // {
  //     code: "TourAgent",
  //     text: "Công ty lữ hành"
  // },
  // {
  //     code: "TourGuide",
  //     text: "Hướng dẫn viên du lịch"
  // },
  // {
  //     code: "HqsManager",
  //     text: "Duyệt dịch vụ du lịch clc"
  // },
  // {
  //     code: "HqsContributor",
  //     text: "Đăng dịch vụ du lịch clc"
  // },
  {
    code: "TrangVangContentManager",
    text: "Quản trị nội dung trang vàng",
  },
  // {
  //     code: "TCQLTT",
  //     text: "Tổng cục quản lý thị trường"
  // },
  // {
  //     code: 'User',
  //     text: "Khách du lịch"
  // },
  // {
  //     code: "VNATAdmin",
  //     text: "Quản trị Việt Nam an toàn"
  // }
];

DataService.accountRolesSearch = [
  {
    code: "Officer",
    text: "Cơ quan quản lý",
  },
  {
    code: "TourAgent",
    text: "Công ty lữ hành",
  },
  {
    code: "User",
    text: "Khách du lịch",
  },
  {
    code: "TourGuide",
    text: "Hướng dẫn viên du lịch",
  },
  {
    code: "HqsManager",
    text: "Duyệt dịch vụ du lịch clc",
  },
  {
    code: "HqsContributor",
    text: "Đăng dịch vụ du lịch clc",
  },
  {
    code: "TrangVangContentManager",
    text: "Quản trị nội dung trang vàng",
  },
  {
    code: "TCQLTT",
    text: "Tổng cục quản lý thị trường",
  },
  {
    code: "VNATAdmin",
    text: "Quản trị Việt Nam an toàn",
  },
];

DataService.accountRolesCreate = [
  {
    code: "Officer",
    text: "Cơ quan quản lý",
  },
  {
    code: "HqsManager",
    text: "Duyệt dịch vụ du lịch clc",
  },
  {
    code: "HqsContributor",
    text: "Đăng dịch vụ du lịch clc",
  },
  {
    code: "TCQLTT",
    text: "Tổng cục quản lý thị trường",
  },
  {
    code: "VNATAdmin",
    text: "Quản trị Việt Nam an toàn",
  },
];

DataService.visibleList = [
  {
    value: true,
    label: "Hiển thị",
  },
  {
    value: false,
    label: "Không hiển thị",
  },
];
DataService.visibleListSearch = [
  {
    value: "true",
    label: "Hiển thị",
  },
  {
    value: "false",
    label: "Không hiển thị",
  },
  {
    value: "",
    label: "Tất cả",
  },
];

DataService.soLuongQuangCao = [
  //
  {
    value: "TrangChu",
    count: 2,
  },
  {
    value: "GioiThieu",
    count: 4,
  },
  {
    value: "DiemDen",
    count: 4,
  },
  {
    value: "ChiTietDiemDen",
    count: 4,
  },
  {
    value: "Tour",
    count: 4,
  },
  {
    value: "ChiTietTour",
    count: 4,
  },
  {
    value: "LuuTru",
    count: 4,
  },
  {
    value: "ChiTietLuuTru",
    count: 4,
  },
  {
    value: "AmThuc",
    count: 4,
  },
  {
    value: "ChiTietAmThuc",
    count: 4,
  },
  {
    value: "GiaiTri",
    count: 4,
  },
  {
    value: "ChiTietGiaiTri",
    count: 4,
  },
  {
    value: "VeDienTu",
    count: 4,
  },
  {
    value: "TinTuc",
    count: 6,
  },
  {
    value: "ChiTietTinTuc",
    count: 4,
  },
];
DataService.processingStatusList = [
  //
  {
    value: "true",
    label: "Đã xử lý",
  },
  {
    value: "false",
    label: "Chưa xử lý",
  },
];
DataService.lockStatusList = [
  {
    value: "true",
    label: "Khoá",
  },
  {
    value: "false",
    label: "Không khoá",
  },
];

DataService.serviceTypeList = [
  {
    value: "Tour",
    label: "Tour",
  },
  {
    value: "Lưu trú",
    label: "Lưu trú",
  },
  {
    value: "Ẩm thực",
    label: "Ẩm thực",
  },
  {
    value: "Điểm đến",
    label: "Điểm đến",
  },
  {
    value: "Giải trí",
    label: "Giải trí",
  },
];

DataService.endowList = [
  {
    value: "K",
    label: "Giảm giá tiền",
  },
  {
    value: "%",
    label: "Giảm giá phần trăm",
  },
];

DataService.linkMangXaHoi = [
  {
    name: "Facebook",
    link: undefined,
  },
  {
    name: "Zalo",
    link: undefined,
  },
  {
    name: "Youtube",
    link: undefined,
  },
  {
    name: "Google",
    link: undefined,
  },
  {
    name: "Twitter",
    link: undefined,
  },
];

DataService.loaiTheHDV = [
  {
    value: "noi_dia",
    label: "Nội địa",
  },
  {
    value: "quoc_te",
    label: "Quốc tế",
  },
  {
    value: "tai_diem",
    label: "Tại điểm",
  },
];

export default DataService;
